import { render, staticRenderFns } from "./AstaNumpad.vue?vue&type=template&id=7f8634e0&scoped=true&"
import script from "./AstaNumpad.vue?vue&type=script&lang=js&"
export * from "./AstaNumpad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8634e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8634e0')) {
      api.createRecord('7f8634e0', component.options)
    } else {
      api.reload('7f8634e0', component.options)
    }
    module.hot.accept("./AstaNumpad.vue?vue&type=template&id=7f8634e0&scoped=true&", function () {
      api.rerender('7f8634e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaNumpad.vue"
export default component.exports